module.exports = __webpack_public_path__ + "img/bg-new-year.51fb3847.svg";